import { useAuth } from "@/contexts/AuthContext";
import { useWhatsAppEmailPrompt } from "./useWhatsAppEmailPrompt";
import { useWhatsAppPhonePrompt } from "./useWhatsAppPhonePrompt";

/**
 * Centralized hook to check if the current user is blocked by WhatsApp verification policies.
 * Returns `isBlocked: true` if the user needs to complete email or phone verification.
 * Returns `isChecking: true` while the checks are still loading.
 */
export function useWhatsAppPolicyStatus() {
  const { user } = useAuth();
  const emailPrompt = useWhatsAppEmailPrompt();
  const phonePrompt = useWhatsAppPhonePrompt();

  // Not logged in — not blocked
  if (!user) {
    return {
      isBlocked: false,
      isChecking: false,
      needsEmail: false,
      needsPhone: false,
    };
  }

  const isChecking = emailPrompt.isChecking || phonePrompt.isChecking;
  const needsEmail = emailPrompt.shouldShow;
  const needsPhone = phonePrompt.shouldShow;
  const isBlocked = needsEmail || needsPhone;

  return { isBlocked, isChecking, needsEmail, needsPhone };
}
